import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
import isPostalCode from 'validator/lib/isPostalCode';

// form validation for dealer
export default function profileValidation(dealer, mode = null) {
  let errors = [];

  if (!dealer.name) {
    errors.push({
      field: 'name',
      test: 'present',
      message: `A company name is required`,
    })
  }

  if (mode !== 'edit') {
    if (!dealer.distributor_location_id) {
      errors.push({
        field: 'distributor_location_id',
        test: 'present',
        message: `A distributor is required`,
      })
    }
  }

  if (!dealer.phone) {
    errors.push({
      field: 'phone',
      test: 'present',
      message: `A phone number is required`,
    })
  }

  if (!dealer.email) {
    errors.push({
      field: 'email',
      test: 'present',
      message: `An email address is required`,
    })
  } else {
    if (!isEmail(dealer.email)) {
      errors.push({
        field: 'email',
        test: 'email',
        message: `A valid email address is required`
      });
    }
  }

  let errorFields = errors.map(e => e.field);

  const validationObject = {
    messages: errors,
    fields: errorFields,
  }

  return validationObject;
}
